"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CreateActionItemResponse () {
        return CreateActionItemResponse;
    },
    get CreateAgendaItemResponse () {
        return CreateAgendaItemResponse;
    },
    get CreateMeetingResponse () {
        return CreateMeetingResponse;
    },
    get CreateMeetingWorkspaceResponse () {
        return CreateMeetingWorkspaceResponse;
    },
    get DismissTranscriptBannerResponse () {
        return DismissTranscriptBannerResponse;
    },
    get ExportCompanyMeetingsResponse () {
        return ExportCompanyMeetingsResponse;
    },
    get ExportWorkspaceMeetingsResponse () {
        return ExportWorkspaceMeetingsResponse;
    },
    get GetActionItemsResponse () {
        return GetActionItemsResponse;
    },
    get GetAgendaItemsResponse () {
        return GetAgendaItemsResponse;
    },
    get GetCarryOverItemsResponse () {
        return GetCarryOverItemsResponse;
    },
    get GetMeetingDetailsResponse () {
        return GetMeetingDetailsResponse;
    },
    get GetMeetingNotesResponse () {
        return GetMeetingNotesResponse;
    },
    get GetMeetingTranscriptResponse () {
        return GetMeetingTranscriptResponse;
    },
    get GetMeetingsResponse () {
        return GetMeetingsResponse;
    },
    get GetUpcomingMeetingsResponse () {
        return GetUpcomingMeetingsResponse;
    },
    get GetWorkspaceResponse () {
        return GetWorkspaceResponse;
    },
    get GetWorkspacesResponse () {
        return GetWorkspacesResponse;
    },
    get ReorderActionItemsResponse () {
        return ReorderActionItemsResponse;
    },
    get ReorderAgendaItemsResponse () {
        return ReorderAgendaItemsResponse;
    },
    get RetrieveMeetingTranscriptOutcome () {
        return RetrieveMeetingTranscriptOutcome;
    },
    get RetrieveMeetingTranscriptResponse () {
        return RetrieveMeetingTranscriptResponse;
    },
    get UpdateActionItemResponse () {
        return UpdateActionItemResponse;
    },
    get UpdateAgendaItemResponse () {
        return UpdateAgendaItemResponse;
    },
    get UpdateMeetingNoteResponse () {
        return UpdateMeetingNoteResponse;
    },
    get UpdateMeetingResponse () {
        return UpdateMeetingResponse;
    },
    get UpdateMeetingTranscriptResponse () {
        return UpdateMeetingTranscriptResponse;
    },
    get UpdateMeetingWorkspaceResponse () {
        return UpdateMeetingWorkspaceResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _generic = require("../generic");
const _actionitem = require("./action-item");
const _agendaitem = require("./agenda-item");
const _meeting = require("./meeting");
const _notes = require("./notes");
const _transcript = require("./transcript");
const _workspace = require("./workspace");
const GetWorkspacesResponse = _zod.z.array(_workspace.WorkspaceExtendedModel);
const GetWorkspaceResponse = _workspace.WorkspaceExtendedModel;
const CreateMeetingWorkspaceResponse = _workspace.WorkspaceModel;
const UpdateMeetingWorkspaceResponse = _workspace.WorkspaceModel;
const GetMeetingsResponse = _zod.z.array(_meeting.MeetingModel);
const GetMeetingDetailsResponse = _zod.z.object({
    meeting: _meeting.MeetingModel,
    workspace: _workspace.WorkspaceExtendedModel,
    /** Names of all users who have data in this meeting (including removed/deactivated) */ participantNames: _zod.z.record(_zod.z.string(), _zod.z.string()).optional(),
    /** Whether the current user has view-only (historical) access to this meeting based on participation intervals */ isHistoricalMeeting: _zod.z.boolean().optional()
});
const CreateMeetingResponse = _meeting.MeetingModel;
const UpdateMeetingResponse = _meeting.MeetingModel.extend({
    calendarOperationType: _meeting.MeetingCalendarOperation,
    videoConferenceOperationType: _meeting.MeetingVideoConferenceOperation
});
const GetCarryOverItemsResponse = _zod.z.object({
    count: _zod.z.number(),
    actionItemIds: _utilsisomorphic.transformObjectId.array(),
    agendaItemIds: _utilsisomorphic.transformObjectId.array()
});
const CreateAgendaItemResponse = _agendaitem.AgendaItemModel;
const UpdateAgendaItemResponse = _agendaitem.AgendaItemModel;
const GetAgendaItemsResponse = _zod.z.array(_agendaitem.AgendaItemModel);
const ReorderAgendaItemsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const CreateActionItemResponse = _actionitem.ActionItemModel;
const UpdateActionItemResponse = _actionitem.ActionItemModel;
const GetActionItemsResponse = _zod.z.array(_actionitem.ActionItemModel);
const ReorderActionItemsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const GetMeetingNotesResponse = _zod.z.array(_notes.MeetingNoteModel);
const UpdateMeetingNoteResponse = _notes.MeetingNoteModel;
const GetMeetingTranscriptResponse = _transcript.MeetingTranscriptModel.nullable();
const UpdateMeetingTranscriptResponse = _transcript.MeetingTranscriptModel;
const RetrieveMeetingTranscriptOutcome = _zod.z.enum([
    "saved",
    "truncated",
    "empty",
    "pending",
    "unavailable",
    "skipped"
]);
const RetrieveMeetingTranscriptResponse = _zod.z.object({
    outcome: RetrieveMeetingTranscriptOutcome
});
const DismissTranscriptBannerResponse = _zod.z.object({
    dismissedTranscriptBanners: _zod.z.array(_models.TranscriptBannerKeySchema)
});
const ExportCompanyMeetingsResponse = _generic.GenericTaskIdResponse;
const ExportWorkspaceMeetingsResponse = _generic.GenericTaskIdResponse;
const GetUpcomingMeetingsResponse = _zod.z.array(_meeting.UpcomingMeetingModel);
